/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  PutApiV1IndividualpaymentParcelsParcelidMutationRequest,
  PutApiV1IndividualpaymentParcelsParcelidMutationResponse,
  PutApiV1IndividualpaymentParcelsParcelidPathParams,
  PutApiV1IndividualpaymentParcelsParcelid400,
  PutApiV1IndividualpaymentParcelsParcelid401,
  PutApiV1IndividualpaymentParcelsParcelid500,
} from "../../types/individualPaymentOperationsController/PutApiV1IndividualpaymentParcelsParcelid.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { putApiV1IndividualpaymentParcelsParcelid } from "../../clients/individualPaymentOperationsController/putApiV1IndividualpaymentParcelsParcelid.ts";

export const putApiV1IndividualpaymentParcelsParcelidMutationKey = () =>
  [{ url: "/api/v1/individualpayment/parcels/:parcelId" }] as const;

export type PutApiV1IndividualpaymentParcelsParcelidMutationKey = ReturnType<
  typeof putApiV1IndividualpaymentParcelsParcelidMutationKey
>;

export function putApiV1IndividualpaymentParcelsParcelidMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PutApiV1IndividualpaymentParcelsParcelidMutationRequest>
  > & { client?: Client } = {},
) {
  const mutationKey = putApiV1IndividualpaymentParcelsParcelidMutationKey();
  return mutationOptions<
    PutApiV1IndividualpaymentParcelsParcelidMutationResponse,
    ResponseErrorConfig<
      | PutApiV1IndividualpaymentParcelsParcelid400
      | PutApiV1IndividualpaymentParcelsParcelid401
      | PutApiV1IndividualpaymentParcelsParcelid500
    >,
    {
      parcelId: PutApiV1IndividualpaymentParcelsParcelidPathParams["parcelId"];
      data?: PutApiV1IndividualpaymentParcelsParcelidMutationRequest;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ parcelId, data }) => {
      return putApiV1IndividualpaymentParcelsParcelid(parcelId, data, config);
    },
  });
}

/**
 * @description Parcela paga só atualiza nº/data da NF. Nosso Número alterado é validado contra outras parcelas e o histórico de boletos do banco. Mudança de multa/pontualidade/valor/vencimento/tipo/número volta a parcela para 'aguardando integração'; troca de método zera a data de integração; matrícula zerada é quitada. Migrado do legado IndividualPayment/EditParcel POST. **(Requer Authorization para autenticação)**
 * @summary Edita uma parcela (Requer Authorization para autenticação)
 * {@link /api/v1/individualpayment/parcels/:parcelId}
 */
export function usePutApiV1IndividualpaymentParcelsParcelid<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PutApiV1IndividualpaymentParcelsParcelidMutationResponse,
      ResponseErrorConfig<
        | PutApiV1IndividualpaymentParcelsParcelid400
        | PutApiV1IndividualpaymentParcelsParcelid401
        | PutApiV1IndividualpaymentParcelsParcelid500
      >,
      {
        parcelId: PutApiV1IndividualpaymentParcelsParcelidPathParams["parcelId"];
        data?: PutApiV1IndividualpaymentParcelsParcelidMutationRequest;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PutApiV1IndividualpaymentParcelsParcelidMutationRequest>
    > & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    putApiV1IndividualpaymentParcelsParcelidMutationKey();

  const baseOptions = putApiV1IndividualpaymentParcelsParcelidMutationOptions(
    config,
  ) as UseMutationOptions<
    PutApiV1IndividualpaymentParcelsParcelidMutationResponse,
    ResponseErrorConfig<
      | PutApiV1IndividualpaymentParcelsParcelid400
      | PutApiV1IndividualpaymentParcelsParcelid401
      | PutApiV1IndividualpaymentParcelsParcelid500
    >,
    {
      parcelId: PutApiV1IndividualpaymentParcelsParcelidPathParams["parcelId"];
      data?: PutApiV1IndividualpaymentParcelsParcelidMutationRequest;
    },
    TContext
  >;

  return useMutation<
    PutApiV1IndividualpaymentParcelsParcelidMutationResponse,
    ResponseErrorConfig<
      | PutApiV1IndividualpaymentParcelsParcelid400
      | PutApiV1IndividualpaymentParcelsParcelid401
      | PutApiV1IndividualpaymentParcelsParcelid500
    >,
    {
      parcelId: PutApiV1IndividualpaymentParcelsParcelidPathParams["parcelId"];
      data?: PutApiV1IndividualpaymentParcelsParcelidMutationRequest;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PutApiV1IndividualpaymentParcelsParcelidMutationResponse,
    ResponseErrorConfig<
      | PutApiV1IndividualpaymentParcelsParcelid400
      | PutApiV1IndividualpaymentParcelsParcelid401
      | PutApiV1IndividualpaymentParcelsParcelid500
    >,
    {
      parcelId: PutApiV1IndividualpaymentParcelsParcelidPathParams["parcelId"];
      data?: PutApiV1IndividualpaymentParcelsParcelidMutationRequest;
    },
    TContext
  >;
}
